import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TransportOptionsAdministrationContext } from '../../transport-options-administration.context';
import { Subscription } from 'rxjs';
import { TransportOptionCondition } from '../../transport-options.model';
import { DialogService } from '@sdbn/common';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'yard-conditions',
  standalone: false,
  templateUrl: './conditions.component.html',
  styleUrl: './conditions.component.scss',
})
export class ConditionsComponent implements OnDestroy, OnInit {



  context: TransportOptionsAdministrationContext;
  contextSubscription: Subscription;

  conditions = new Array<TransportOptionCondition>();

  @Input() set optionsContext(optionsContext: TransportOptionsAdministrationContext) {
    this.context = optionsContext;
    this.contextSubscription = this.context.contextChange$.subscribe(contextChange => {
      if (contextChange.key === 'conditions-changed') {
        this.conditions = this.context.conditions;
      }
    });
    this.conditions = this.context.conditions;
  }

  constructor(
    private dialogService: DialogService
  ) { }

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
    this.contextSubscription.unsubscribe();
  }

  public addCondition() {
    this.context.conditions.push(new TransportOptionCondition({ id: uuidv4() }));
    this.conditions = this.context.conditions;
    this.context.dirty = true;
  }

  onDeleteRequested(condition: TransportOptionCondition) {
    this.dialogService.showConfirm('tmc-yard.ui.admin.transport-options-administration.delete-condition-title', 'tmc-yard.ui.admin.transport-options-administration.delete-condition-message').afterClosed().subscribe(result => {
      if (result) {
        if (this.context.conditions.indexOf(condition) > -1) {
          this.context.conditions.splice(this.context.conditions.indexOf(condition), 1);
          this.conditions = this.context.conditions;
          this.context.dirty = true;
        }
      }
    });
  }
}
